import { render, staticRenderFns } from "./LoginPopupAccountGlobal.vue?vue&type=template&id=b978b6e2&scoped=true&"
import script from "./LoginPopupAccountGlobal.vue?vue&type=script&lang=js&"
export * from "./LoginPopupAccountGlobal.vue?vue&type=script&lang=js&"
import style0 from "./LoginPopupAccountGlobal.vue?vue&type=style&index=0&id=b978b6e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b978b6e2",
  null
  
)

component.options.__file = "LoginPopupAccountGlobal.vue"
export default component.exports